module.exports = __webpack_public_path__ + "./welfare-01_2d5146ea5e67d3096f7628f5eaef8cdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionWork/2025/welfare-01.jpg
// module id = 625
// module chunks = 0